class LockdownService extends BaseService
	@register()
	@inject '$rootScope',
		'CredentialsManager'
		'UserInformation'
		'MasterUserRepository'
		'$uibModal'

	init: ->
		unregister = @$rootScope.$watch(
			=>
				@CredentialsManager.getId()
			(newId) =>
				currentId = @UserInformation.getMasterUser()?.id

				if currentId == null || newId == null || currentId == newId
					return

				console.warn('User ID has changed - initiating system lockdown')
				unregister()

				@lock()
		)

	lock: ->
		@$rootScope.isLockdown = true
		@MasterUserRepository.lock()
		@showModal()

	showModal: ->
		@$uibModal.open
			templateUrl: '@service/lockdown/modals/lockdown.modal.view.html'
			backdrop: 'static'
			keyboard: false
			bindToController: true
			controllerAs: 'lockdownModal'
			controller: ($uibModalInstance, $window) ->
				$onInit: ->
					@$uibModalInstance = $uibModalInstance
					@$window = $window

				reload: ->
					@$window.location.reload()

				continue: ->
					@$uibModalInstance.close()
